const HOME_PAGE_DEFAULTS = {
  animated: true,
  widgetHeight: 368,
  widgetWidth: 360,
  cols: 3,
  gap: 16,
  gapX: 16,
  gapY: 12
};

const EVENTS = { resized: 'resized' };

export { HOME_PAGE_DEFAULTS, EVENTS };
